import { useState } from 'react';
import { FaStar, FaCheckCircle, FaHome, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './reviews-grid.css';

const ReviewsGrid = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const reviewsPerPage = 9; // Show 9 reviews per page (3x3 grid)

    const reviews = [
        {
            name: 'Krishna Reddy',
            location: 'Amaravati',
            propertyType: 'Villa',
            rating: 5,
            review: 'Royale Spaces helped us find our dream villa in Amaravati. Their transparency and professionalism made the entire process smooth and stress-free.',
            avatar: 'https://ui-avatars.com/api/?name=Krishna+Reddy&background=667eea&color=fff&size=80',
            verified: true,
            date: 'March 2025'
        },

        {
            name: 'Ananya Singh',
            location: 'Hyderabad',
            propertyType: 'Apartment',
            rating: 5,
            review: 'Excellent service and professional team. They helped me find the perfect property in Amaravati. Highly recommended for anyone looking for real estate.',
            avatar: 'https://ui-avatars.com/api/?name=Ananya+Singh&background=10b981&color=fff&size=80',
            verified: true,
            date: 'March 2025'
        },

        {
            name: 'Ramesh Patel',
            location: 'Amaravati',
            propertyType: 'Commercial',
            rating: 5,
            review: 'Outstanding experience from start to finish. The transparency and genuine service provided by Royale Spaces made our property purchase smooth and hassle-free.',
            avatar: 'https://ui-avatars.com/api/?name=Ramesh+Patel&background=f97316&color=fff&size=80',
            verified: true,
            date: 'February 2025'
        },
        {
            name: 'Priya Sharma',
            location: 'Hyderabad',
            propertyType: 'Plot',
            rating: 5,
            review: 'Best real estate company in Amaravati! They guided us through every step and helped us get the best deal on our agricultural land.',
            avatar: 'https://ui-avatars.com/api/?name=Priya+Sharma&background=ec4899&color=fff&size=80',
            verified: true,
            date: 'February 2025'
        },
        {
            name: 'Rajesh Kumar',
            location: 'Amaravati',
            propertyType: 'Residential',
            rating: 5,
            review: 'Professional service and great support throughout the buying process. Royale Spaces made our dream of owning property in Amaravati come true.',
            avatar: 'https://ui-avatars.com/api/?name=Rajesh+Kumar&background=8b5cf6&color=fff&size=80',
            verified: true,
            date: 'January 2025'
        },
        {
            name: 'Anita Reddy',
            location: 'Hyderabad',
            propertyType: 'Villa',
            rating: 5,
            review: 'Trustworthy and reliable. The team at Royale Spaces went above and beyond to ensure we found the perfect property that matched our requirements.',
            avatar: 'https://ui-avatars.com/api/?name=Anita+Reddy&background=06b6d4&color=fff&size=80',
            verified: true,
            date: 'January 2025'
        },
        {
            name: 'Vijay Patel',
            location: 'Amaravati',
            propertyType: 'Commercial',
            rating: 5,
            review: 'Excellent guidance throughout the property buying journey. Royale Spaces helped us secure a prime commercial plot in the capital region.',
            avatar: 'https://ui-avatars.com/api/?name=Vijay+Patel&background=f59e0b&color=fff&size=80',
            verified: true,
            date: 'December 2024'
        },
        {
            name: 'Lakshmi Devi',
            location: 'Amaravati',
            propertyType: 'Residential',
            rating: 5,
            review: 'Very professional and transparent service. They made the entire process of buying our first home stress-free and enjoyable.',
            avatar: 'https://ui-avatars.com/api/?name=Lakshmi+Devi&background=ef4444&color=fff&size=80',
            verified: true,
            date: 'December 2024'
        },
        {
            name: 'Karthik Rao',
            location: 'Hyderabad',
            propertyType: 'Plot',
            rating: 5,
            review: 'Great experience with Royale Spaces. Their market knowledge and professional approach helped us make the right investment decision.',
            avatar: 'https://ui-avatars.com/api/?name=Karthik+Rao&background=3b82f6&color=fff&size=80',
            verified: true,
            date: 'November 2024'
        },
        {
            name: 'Deepa Menon',
            location: 'Amaravati',
            propertyType: 'Villa',
            rating: 5,
            review: 'Highly recommend Royale Spaces for anyone looking to invest in Amaravati. Their team is knowledgeable, responsive, and genuinely helpful.',
            avatar: 'https://ui-avatars.com/api/?name=Deepa+Menon&background=a855f7&color=fff&size=80',
            verified: true,
            date: 'November 2024'
        },
        {
            name: 'Suresh Babu',
            location: 'Hyderabad',
            propertyType: 'Apartment',
            rating: 5,
            review: 'Outstanding service from start to finish. Royale Spaces made our property purchase smooth with their expertise and dedication.',
            avatar: 'https://ui-avatars.com/api/?name=Suresh+Babu&background=14b8a6&color=fff&size=80',
            verified: true,
            date: 'October 2024'
        },
        {
            name: 'Meena Krishnan',
            location: 'Amaravati',
            propertyType: 'Commercial',
            rating: 5,
            review: 'Professional team with excellent market insights. They helped us find the perfect commercial space for our business expansion.',
            avatar: 'https://ui-avatars.com/api/?name=Meena+Krishnan&background=f97316&color=fff&size=80',
            verified: true,
            date: 'October 2024'
        },
        {
            name: 'Arun Kumar',
            location: 'Hyderabad',
            propertyType: 'Residential',
            rating: 5,
            review: 'Royale Spaces exceeded our expectations. Their transparent approach and attention to detail made all the difference in our property search.',
            avatar: 'https://ui-avatars.com/api/?name=Arun+Kumar&background=84cc16&color=fff&size=80',
            verified: true,
            date: 'September 2024'
        },
        {
            name: 'Divya Sharma',
            location: 'Amaravati',
            propertyType: 'Plot',
            rating: 5,
            review: 'Best real estate company we have worked with. Their professionalism and market knowledge are unmatched in the region.',
            avatar: 'https://ui-avatars.com/api/?name=Divya+Sharma&background=ec4899&color=fff&size=80',
            verified: true,
            date: 'September 2024'
        },
        {
            name: 'Ramesh Reddy',
            location: 'Hyderabad',
            propertyType: 'Villa',
            rating: 5,
            review: 'Exceptional service and support throughout our property buying journey. Royale Spaces truly cares about their clients.',
            avatar: 'https://ui-avatars.com/api/?name=Ramesh+Reddy&background=6366f1&color=fff&size=80',
            verified: true,
            date: 'August 2024'
        },
        {
            name: 'Kavitha Nair',
            location: 'Amaravati',
            propertyType: 'Apartment',
            rating: 5,
            review: 'Highly satisfied with the service provided by Royale Spaces. They made our dream of owning property in Amaravati a reality.',
            avatar: 'https://ui-avatars.com/api/?name=Kavitha+Nair&background=06b6d4&color=fff&size=80',
            verified: true,
            date: 'August 2024'
        }
    ];

    // Calculate pagination
    const indexOfLastReview = currentPage * reviewsPerPage;
    const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
    const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);
    const totalPages = Math.ceil(reviews.length / reviewsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <section className="reviews-grid-section">
            <div className="container">
                <div className="reviews-header">
                    <h2>What Our Clients Say</h2>
                    <p>Real experiences from real customers who trusted Royale Spaces for their property needs</p>
                    <div className="reviews-count">
                        Showing {indexOfFirstReview + 1}-{Math.min(indexOfLastReview, reviews.length)} of {reviews.length} reviews
                    </div>
                </div>

                <div className="reviews-grid">
                    {currentReviews.map((review, index) => (
                        <div key={index} className="review-grid-card">
                            <div className="review-card-header">
                                <div className="reviewer-avatar-section">
                                    <img src={review.avatar} alt={review.name} className="reviewer-avatar-grid" />
                                    {review.verified && (
                                        <div className="verified-badge-grid">
                                            <FaCheckCircle />
                                        </div>
                                    )}
                                </div>
                                <div className="reviewer-info-grid">
                                    <h4>{review.name}</h4>
                                    <div className="property-meta">
                                        <span className="property-type-badge">
                                            <FaHome /> {review.propertyType}
                                        </span>
                                        <span className="review-location">{review.location}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="rating-section">
                                {[...Array(review.rating)].map((_, i) => (
                                    <FaStar key={i} className="star-icon-grid" />
                                ))}
                            </div>

                            <p className="review-text-grid">"{review.review}"</p>

                            <div className="review-footer">
                                <span className="review-date">{review.date}</span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="pagination-container">
                        <button
                            className="pagination-btn-1 prev-btn"
                            onClick={handlePrevious}
                            disabled={currentPage === 1}
                        >
                            <FaChevronLeft /> Previous
                        </button>

                        <div className="pagination-numbers">
                            {[...Array(totalPages)].map((_, index) => {
                                const pageNumber = index + 1;
                                // Show first page, last page, current page, and pages around current
                                if (
                                    pageNumber === 1 ||
                                    pageNumber === totalPages ||
                                    (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
                                ) {
                                    return (
                                        <button
                                            key={pageNumber}
                                            className={`pagination-number ${currentPage === pageNumber ? 'active' : ''}`}
                                            onClick={() => handlePageChange(pageNumber)}
                                        >
                                            {pageNumber}
                                        </button>
                                    );
                                } else if (
                                    pageNumber === currentPage - 2 ||
                                    pageNumber === currentPage + 2
                                ) {
                                    return <span key={pageNumber} className="pagination-dots">...</span>;
                                }
                                return null;
                            })}
                        </div>

                        <button
                            className="pagination-btn-1 next-btn"
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                        >
                            Next <FaChevronRight />
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default ReviewsGrid;
